import { type FC } from "react";

import { type CellInfo } from "~/models/cell";

export const ImportView: FC<{
	cellInfo: CellInfo;
}> = ({ cellInfo }) => {
	const staticAnalysis = cellInfo.analysis?.inspectInfo;

	if (
		!(
			staticAnalysis?.kind === "NamespacedCanvasImportInfo" ||
			staticAnalysis?.kind === "PageImportInfo"
		)
	) {
		return <></>;
	}

	const specifiers = Object.values(staticAnalysis.specifiers);
	let arg;
	if (staticAnalysis.argument.type === "fromMomentNamespace") {
		const { namespace, canvasName, pageSlug } = staticAnalysis.argument;
		const argText = `d/${namespace}/${canvasName}${pageSlug ? `/${pageSlug}` : ""}`;
		arg = (
			<a
				className="text-syntax-keyword"
				href={`${window.location.origin}/${argText}`}
				target={argText}
			>
				{`"${argText}"`}
			</a>
		);
	} else {
		arg = `"./${staticAnalysis.argument.slug}"`;
	}

	return (
		<div className={`text-syntax-normal w-full font-mono text-sm font-normal`}>
			<div>
				<span className="text-syntax-keyword">import</span>
				{" { "}
				{specifiers.map((sp, i) => {
					return (
						<span key={i}>
							{sp.imported === sp.localIdentifier ? (
								<span className="text-syntax-known-variable">
									{sp.localIdentifier}
								</span>
							) : (
								<>
									<span className="text-syntax-known-variable">
										{sp.imported}
									</span>{" "}
									<span className="text-syntax-keyword">as</span>{" "}
									<span className="text-syntax-known-variable">
										{sp.localIdentifier}
									</span>
								</>
							)}
							{i < specifiers.length - 1 && ", "}
						</span>
					);
				})}
				{" } "}
				<span className="text-syntax-keyword">from</span>{" "}
				<span className="text-syntax-string">{arg}</span>
			</div>
		</div>
	);
};
